<div class="border-bottom">
  <nav class="navbar navbar-static-top white-bg" role="navigation" style="margin-bottom: 0">
    <span class="logodash"><img src="assets/img/demologo1.png" alt="not found" /></span>
    <ul class="nav navbar-top-links navbar-right">
      <li class="nav-header">
        <div class="dropdown profile-element">
          <span style="display: none;">
            <img alt="image" class="img-circle" width="80px" src="./assets/img/avatar/avatar.png" />
          </span>
          <a data-toggle="dropdown" class="dropdown-toggle" href="#">

            <strong class="prfname">Welcome {{ fname }} {{ lname }}</strong>
            <span class="tmdiv" id="date_time"> Oct 11, 2018 1:02:02 PM</span>
          </a>
        </div>
        <div class="logo-element"></div>
      </li>
      <li>
        <a>
          <img src="assets/img/logout.png" alt="not found" />
          <input type="submit" class="btn2 btn-success2" (click)="logout()" value="Log Out" />

          <em class="fa fa-sign-out"></em>
        </a>
      </li>
    </ul>
  </nav>
</div>